import { Loader2 } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

/**
 * GlobalLoader - Shows loading state for all API calls except session-related ones
 * IMPORTANT: This loader should NEVER be shown at the same time as SecureLoader
 * SecureLoader handles: validateSession, getSession, terminateSession
 * GlobalLoader handles: All other API calls
 */
export const GlobalLoader: React.FC = () => {
  const { t } = useTranslation();
  const { isLoading, loadingMessage } = useSelector(
    (state: RootState) => state.loader
  );
  const isSessionLoading = useSelector(
    (state: RootState) => state.session?.loading === true
  );
  // Don't show GlobalLoader if SecureLoader is active
  if (isSessionLoading) {
    return null;
  }

  // Don't show if not loading
  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="flex flex-col items-center p-8 space-y-4 bg-white rounded-2xl shadow-2xl">
        <Loader2 className="w-12 h-12 animate-spin text-primary-600" />
        <div className="flex flex-col items-center space-y-2">
          <p className="text-lg font-semibold text-neutral-900">
            {loadingMessage || t("common.loading")}
          </p>
          <p className="text-sm text-neutral-500">{t("common.pleaseWait")}</p>
        </div>
      </div>
    </div>
  );
};
